export class Log {
    items: Record<any, any> = [];

    clear() {
        this.items = [];
    }

    add(item: Record<any, any>) {
        this.items.push(item);
    }
}